import React, { useState, useCallback, ReactElement } from 'react';
import { Carousel as RRC } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Lightbox, { Modal, ModalGateway } from 'react-images';
import { CarouselProps, Image } from '../interfaces';
import { server } from '../const/axios';

export function buildCarousel(paths: string[], i: number, id: string): Image[] {
	return paths.map((name, j) => {
		let src = [server, 'gallery', id, i.toString(), name].join('/');
		return {
			key: id + '.' + i.toString() + '.' + j.toString(),
			alt: name.toLowerCase().replace(/\s+/g, '_').replace('.jpg', ''),
			index: j,
			src,
			caption: name.toLowerCase()
				.replace(/\s+/g, '_')
				.replace('.jpg', '')
		};
	});
}

export default function Carousel(props: CarouselProps): ReactElement {
	const [currentImage, setCurrentImage] = useState(props.selectedItem || 0);
	const [viewerIsOpen, setViewerIsOpen] = useState(false);

	const openLightbox = useCallback((event, { photo, index }) => {
		setCurrentImage(index);
		setViewerIsOpen(true);
	}, []);

	const closeLightbox = () => {
		setCurrentImage(props.selectedItem || 0);
		setViewerIsOpen(false);
	};

	return (
		<div
			className='Carousel'
		>
			<RRC
				{...props}
				width={props.width}
				onClickItem={props.enableLightbox !== false ? openLightbox : () => {}}
			/>
			{props.enableLightbox !== false ? (
				<ModalGateway>
					{viewerIsOpen ? (
						<Modal onClose={closeLightbox}>
							<Lightbox
								onClose={closeLightbox}
								currentImage={currentImage}
								views={props.photos}
							/>
						</Modal>
					) : null}
				</ModalGateway>
			) : null}
		</div>
	);
}
